import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchPolicyDetails(data: any) {
  const response = await instance.post(`/ethics/getEthicsPolicyDetails?ethicsPolicyId=${data}`);
  return response.data;
}
